<script lang="ts" setup>
  import type * as CSS from 'csstype'

  const props = defineProps<{
    typeformId: string
    backgroundColor?: CSS.Property.BackgroundColor
  }>()

  declare global {
    interface Window {
      tf?: {
        load?: () => void
      }
    }
  }

  const typeformScriptSrc = 'https://embed.typeform.com/next/embed.js'
  const didCreateScript = ref(false)

  function initializeTypeform() {
    window.tf?.load?.()
  }

  onMounted(async () => {
    if (!props.typeformId) {
      return
    }

    await nextTick()

    const existingScript = document.querySelector(`script[src="${typeformScriptSrc}"]`) as HTMLScriptElement | null

    if (existingScript) {
      initializeTypeform()
      return
    }

    const script = document.createElement('script')
    script.src = typeformScriptSrc
    script.async = true
    script.addEventListener('load', initializeTypeform)

    document.body.appendChild(script)
    didCreateScript.value = true
  })

  onUnmounted(() => {
    if (!didCreateScript.value) {
      return
    }

    const script = document.querySelector(`script[src="${typeformScriptSrc}"]`)
    script?.parentNode?.removeChild(script)
  })
</script>

<template>
  <div class="c-typeform">
    <client-only>
      <div :data-tf-live="typeformId" class="c-typeform__embed" />
    </client-only>
  </div>
</template>

<style lang="scss" scoped>
  .c-typeform {
    background-color: v-bind(backgroundColor);
  }

  .c-typeform__embed {
    width: 100%;
    min-height: 720px;
  }

  .c-typeform__embed:deep(iframe) {
    width: 100%;
    min-height: 720px;
  }
</style>
